module.exports = __webpack_public_path__ + "img/male_profile.44a8eed7.svg";